const getDefaultState = () => ({
  responses: {}
})

export const state = getDefaultState

export const mutations = {
  RESET (state) {
    Object.assign(state, getDefaultState())
  },
  SET (state, { path, response }) {
    if (!response.resolved) return
    state.responses = {
      ...state.responses,
      [path]: response
    }
  }
}

export const getters = {
  // cmsDetails: state => path => ((Object.entries(state.responses).find(
  //   ([fullPath, response]) => response.path === path
  // ) || {}).cms) || {}
  response: state => path => Object.values(state.responses).find(response => response.path === path) || {},
  cmsDetails: (state, getters) => path => getters.response(path).cms || {},
  routeForSku: state => (sku) => {
    let route = (Object.values(state.responses).find(response => response.sku_prefix === sku) || {}).path
    if (!route) return null
    if (!route.startsWith('/')) route = `/${route}`
    return route
  }
}

export const actions = {
  async RESOLVE ({ commit, state }, path) {
    if (path in state.responses) return state.responses[path]

    const { data } = await this.$publicAPI.get(`routes/resolve/?path=${path}`)
    commit('SET', { path, response: data })
    return data
  },
  async RESOLVE_COMMON_ROUTES ({ commit }) {
    const { data } = await this.$publicAPI.get('routes/resolve_common_routes/', { useCache: true })
    Object.entries(data).forEach(
      ([path, response]) => commit('SET', { path, response })
    )
  }
}
